




























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import {
    TransportDeviationCategory,
    TransportParty,
    TransportTask,
    TransportUnitType,
} from "@/models";

import {
    transportDeviationService,
    transportUnitTypeService,
} from "@/services";

@Component
export default class MissingUnitDialog extends Vue {
    @Prop() unitNumber!: string;
    @Prop() task!: TransportTask;
    @Prop() party!: TransportParty;

    sending = false;

    unitTypes: null | TransportUnitType[] = null;
    deviationCategory: null | TransportDeviationCategory = null;

    unitType: null | TransportUnitType = null;

    async mounted() {
        const result = await Promise.all([
            transportUnitTypeService.listUnitTypes(),
            transportDeviationService.listDeviationCategories()
        ]);

        this.unitTypes = result[0].items;
        this.deviationCategory = result[1].find(c => c.missingUnit) || null;

        if (!this.deviationCategory) {
            // FIXME
            alert("Configuration error: no missing unit deviation type.");
            this.$emit("close");
        }
    }

    async send() {
        this.sending = true;

        await transportDeviationService.createDeviation({
            deviationCategoryId: this.deviationCategory!.deviationCategoryId,
            taskId: this.task.taskId,
            message: `${this.unitNumber} ${this.unitType!.typeName} ${this.party ? this.party.partyName : ""}`,
        });

        this.$emit("done");
    }
}
